const routerName = {
    todolist: {
        approval: 'approval',
        revise: 'revise',
        draft: 'draft',
        cancel: 'cancel',
        approvalhistory: 'approvalhistory'
    }
};
export default routerName;
